import { Button } from "reactstrap";
import { FiSearch } from "react-icons/fi";
import { createNanoEvents } from "utils/eventEmitter";
import { capitalize } from "utils/capitalize";

export const claimsTableAction =
	({ showModal }) =>
	// eslint-disable-next-line react/display-name
	(row) =>
		(
			<div className="actions-right">
				<Button color="warning" size="sm" className="btn-icon btn-link edit my-0" onClick={() => showModal(row)}>
					<FiSearch size={20} />
				</Button>
			</div>
		);

export const claimStatusMap = {
	pending: <span className="text-warning">Pending</span>,
	paid: <span className="text-success">Paid</span>,
	rejected: <span className="text-danger">Rejected</span>,
	approved: <span className="text-success">Approved</span>,
};

export const claimsTableColumn = [
	{
		id: "actions",
		header: "View",
		accessor: (row) => (
			<div className="actions-right">
				<Button
					color="warning"
					size="sm"
					className="btn-icon btn-link edit my-0"
					onClick={() => claimsTableModalEmitter.emit("showModal", row)}
				>
					<FiSearch size={20} />
				</Button>
			</div>
		),
		sortable: false,
		filterable: false,
	},
	{
		id: "id",
		header: "ID",
		accessor: (row) => row.id,
		sortable: true,
		filterable: true,
	},
	{
		id: "lessonDate",
		header: "Date",
		accessor: (row) => row?.createdAt || <span className="text-muted">N/A</span>,
		sortable: true,
		filterable: true,
	},
	{
		id: "claimPeriod",
		header: "Period (Month)",
		accessor: (row) => capitalize(row?.claimPeriod) || <span className="text-muted">N/A</span>,
		sortable: true,
		filterable: true,
	},
	{
		id: "lessonCentre",
		header: "Centre",
		accessor: (row) => row.centre,
		sortable: true,
		filterable: true,
	},
	{
		id: "company",
		header: "Company",
		accessor: (row) => row.company,
		filterable: true,
	},
	{
		id: "staffName",
		header: "Staff Name",
		accessor: (row) => row.staff?.fullName,
		sortable: true,
		filterable: true,
	},
	{
		id: "price",
		header: "Total Amount",
		accessor: (row) => <div className="text-right">{row.price}</div>,
		sortable: true,
		filterable: true,
	},
	{
		id: "status",
		header: "Status",
		accessor: (row) => claimStatusMap[row.status],
		filterable: true,
	},
	{
		id: "isPettyCash",
		header: "Claim Type",
		accessor: (row) => (row.isPettyCash ? <div>Petty C</div> : <div>Cheque</div>),
		filterable: true,
	},
	{
		id: "approvedBy",
		header: "Reviewed By",
		accessor: (row) => row.approvedBy?.fullName || <span className="text-muted">Not reviewed</span>,
		filterable: true,
	},
];

export const claimsTableModalEmitter = createNanoEvents();
